import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostCreateRequestPreview,
	PostCreateRequestPreviewResponse,
	PostCreateRequestPreviewParams,
} from 'domain/usecases/private/refund/request-preview';

export class RemotePostCreateRequestPreview implements PostCreateRequestPreview {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostCreateRequestPreviewResponse>,
	) {}

	async post(params: PostCreateRequestPreviewParams): Promise<PostCreateRequestPreviewResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
